import type { ConfigurationFacet } from '../types'

/**
 * Returns an object mapping each facet's name to an empty array.
 *
 * @param facets - Array of facet objects.
 * @returns An object where each key is a facet name, and each value is an empty array.
 */
export function getInitialFiltersDict(facets: ConfigurationFacet[]) {
  return facets.reduce<Record<string, string[]>>((acc, item) => {
    return { ...acc, [item.name]: [] }
  }, {})
}
